<template>
  <MainAuthLayout>
    <template v-slot:form>
      <router-view />
    </template>
  </MainAuthLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import MainAuthLayout from '../layouts/MainAuthLayout'

export default {
  components: {
    MainAuthLayout,
  },

  computed: {
    ...mapState({
      isAuthenticated: (state) => state.auth.isAuthenticated,
      user: (state) => state.auth.user,
    }),
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
    }),
  },

  async created() {
    const authRoutes = [
      'auth.login-page',
      'auth.register-page',
      'auth.forgot-password-page',
    ]
    if (this.isAuthenticated) {
      if (!this.user) {
        await this.getAuthenticatedUser()
      }

      this.$router.replace({ name: 'home' })
    } else if (!authRoutes.includes(this.$route.name)) {
      this.$router.replace({ name: 'auth' }).catch(() => {})
    }
  },
}
</script>

<style lang="scss" scoped>
.template-container {
  width: 500px;
}
@media (max-width: 576px) {
  .template-container {
    width: 100%;
  }
}
</style>
